
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexVmlAMsOu0EWO6v3wFI49RUBwc7AU_45coceEL3p1BzhN8Meta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/index.vue?macro=true";
import { default as logout5OEUUV0N_yVltW8Rje00D3k5sJuENZldMQ71cxV8O3QMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/logout.vue?macro=true";
import { default as busqueda3RytZP8Cfqfo07iln6Z5aogtYiIQlTjdTHIufs06GzsMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/busqueda.vue?macro=true";
import { default as _91_46_46_46slug_93Yuit8ipKm_45crazx0G6WH3z9rPoL7TJdU9lnlVQGxxtYMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/[...slug].vue?macro=true";
import { default as indexK2n2u_45dN6ZqqUjqHiFuVE_y_45rVvCEqLsyu2Z_45sRzfkUMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/compra/index.vue?macro=true";
import { default as crear_45cuenta3SeSVEqzB3qXdlTkb9KkdzSqnMUAyYh5V102kDzvFyQMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/crear-cuenta.vue?macro=true";
import { default as _91id_93YzV41jVoJL5ZDsY7IPirXtv4RnnYhfwZY6Zlqtkos9sMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/encuestas/[id].vue?macro=true";
import { default as iniciar_45sesionIJ5_45m6tTsLJdWgiWSAZOmZAaq0A48Y82yIT9WBDc26kMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/iniciar-sesion.vue?macro=true";
import { default as index3E8PIBLQWwnf13VCC5UJ_NtiwJFHnD5GXCxtCeyVwJsMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/tarifario/index.vue?macro=true";
import { default as accesoyG0yXf0ZEShb_45PDBHlBZNaZj1oKFiC1Fb_nL0n6S84cMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/tarifario/acceso.vue?macro=true";
import { default as calendario_45de_45cursosqtHu5_45EK2_45pHxN3Xqb1TWjBuiHueCZUpokeq1X2QbYQMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/calendario-de-cursos.vue?macro=true";
import { default as indexUMYf5XDMeruJ5fJ2Ea2ZRiooNZESPbxTlw_Iw5kJsjQMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/blog/[blogSlug]/index.vue?macro=true";
import { default as iniciar_45sesioneArRDMsJKW1t_IYmBaFcG6F5j01I4Bi70905J3rG0KcMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/compra/iniciar-sesion.vue?macro=true";
import { default as _91token_9356d_45syQXQRqFQFqf9ukUikE_XGvRDWu_45SCMifv_UMgcMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/activar-cuenta/[token].vue?macro=true";
import { default as perfilohl352m_9U_BoXr_45kpBHEC9kkXsLq_45nf3cYJK_45UL88MMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/zona-de-cliente/perfil.vue?macro=true";
import { default as _91productSlug_93wNMh5q1MQGMmSTL_45xcX_456qyWLnJWIntUIPw1PWHG7DIMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/tarifario/[productSlug].vue?macro=true";
import { default as confirma_45tu_45pedidoTxpzWU3v0wbIBlCP100irkduWkuQuVdajtppDaMTs1sMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/compra/confirma-tu-pedido.vue?macro=true";
import { default as envio_45y_45facturacionq18e2yAZLRr0qhuZpWz_45jH2rXY1RjxmRCGQ__EVS_cgMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/compra/envio-y-facturacion.vue?macro=true";
import { default as solicitar_45nueva_45contrasenawhGn_T08YZ6yWoEoifSKHxQGunZJ6sQE5s1OR2wNFjIMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/solicitar-nueva-contrasena.vue?macro=true";
import { default as indexmK27_45q_Y4h50aSfVOkSSKsMFm8KWUIbfX4RLgoaEjHAMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/tienda/[categorySlug]/index.vue?macro=true";
import { default as _91token_93WjGkjngK55J0AF3yY1yXaMbE9_45Bwjug7vO0uT1gtvQUMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/modificar-contrasena/[token].vue?macro=true";
import { default as indexeVKhC_45Vl4nfnfHPZRIuf7b86Y5dY40xL81XOoltkwy0Meta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/zona-de-cliente/cursos/index.vue?macro=true";
import { default as _91articleSlug_93919zvFgmm_45Uymr0FqM1k2Vd5eKJcZPeMTxASaZ7rBwUMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/blog/[blogSlug]/[articleSlug].vue?macro=true";
import { default as indexNTDIoCkLrKaFbN1McW_GAHz_45q5gB4ObUqin_5zYlNesMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/zona-de-cliente/pedidos/index.vue?macro=true";
import { default as _91courseId_936g2hyQIHdwV8MiJXdmI2ipk0pYGI03rQJ8TGWv6Ma_45sMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/zona-de-cliente/cursos/[courseId].vue?macro=true";
import { default as _91productSlug_931dnPZcruZ7ILX_11oadnepz9F3QT47qUXAmwTr2Z_450AMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/tienda/[categorySlug]/[productSlug].vue?macro=true";
import { default as _91orderNumber_939V_45Zel5_45MlJkKxMg6eM9_45QHq0So4VQLBzjE90MBBqdsMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/compra/pedido-realizado/[orderNumber].vue?macro=true";
import { default as _91productSlug_937sXpuDDnZZMYQJnqy_1FeaS_45rjK_45LoFAdSEQLoLfItAMeta } from "/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/cursos-online-para-profesionales/[productSlug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/index.vue")
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/logout.vue")
  },
  {
    name: "busqueda",
    path: "/busqueda",
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/busqueda.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/[...slug].vue")
  },
  {
    name: "compra",
    path: "/compra",
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/compra/index.vue")
  },
  {
    name: "crear-cuenta",
    path: "/crear-cuenta",
    meta: {"middleware":"only-not-authenticated"},
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/crear-cuenta.vue")
  },
  {
    name: "encuestas-id",
    path: "/encuestas/:id()",
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/encuestas/[id].vue")
  },
  {
    name: "iniciar-sesion",
    path: "/iniciar-sesion",
    meta: {"middleware":"only-not-authenticated"},
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/iniciar-sesion.vue")
  },
  {
    name: "tarifario",
    path: "/tarifario",
    meta: {"middleware":"only-price-table-authenticated"},
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/tarifario/index.vue")
  },
  {
    name: "tarifario-acceso",
    path: "/tarifario/acceso",
    meta: {"middleware":"only-not-price-table-authenticated"},
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/tarifario/acceso.vue")
  },
  {
    name: "calendario-de-cursos",
    path: "/calendario-de-cursos",
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/calendario-de-cursos.vue")
  },
  {
    name: "blog-blogSlug",
    path: "/blog/:blogSlug()",
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/blog/[blogSlug]/index.vue")
  },
  {
    name: "compra-iniciar-sesion",
    path: "/compra/iniciar-sesion",
    meta: {"middleware":"only-not-authenticated"},
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/compra/iniciar-sesion.vue")
  },
  {
    name: "activar-cuenta-token",
    path: "/activar-cuenta/:token()",
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/activar-cuenta/[token].vue")
  },
  {
    name: "zona-de-cliente-perfil",
    path: "/zona-de-cliente/perfil",
    meta: {"middleware":"only-authenticated"},
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/zona-de-cliente/perfil.vue")
  },
  {
    name: "tarifario-productSlug",
    path: "/tarifario/:productSlug()",
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/tarifario/[productSlug].vue")
  },
  {
    name: "compra-confirma-tu-pedido",
    path: "/compra/confirma-tu-pedido",
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/compra/confirma-tu-pedido.vue")
  },
  {
    name: "compra-envio-y-facturacion",
    path: "/compra/envio-y-facturacion",
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/compra/envio-y-facturacion.vue")
  },
  {
    name: "solicitar-nueva-contrasena",
    path: "/solicitar-nueva-contrasena",
    meta: {"middleware":"only-not-authenticated"},
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/solicitar-nueva-contrasena.vue")
  },
  {
    name: "tienda-categorySlug",
    path: "/tienda/:categorySlug()",
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/tienda/[categorySlug]/index.vue")
  },
  {
    name: "modificar-contrasena-token",
    path: "/modificar-contrasena/:token()",
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/modificar-contrasena/[token].vue")
  },
  {
    name: "zona-de-cliente-cursos",
    path: "/zona-de-cliente/cursos",
    meta: {"middleware":"only-authenticated"},
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/zona-de-cliente/cursos/index.vue")
  },
  {
    name: "blog-blogSlug-articleSlug",
    path: "/blog/:blogSlug()/:articleSlug()",
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/blog/[blogSlug]/[articleSlug].vue")
  },
  {
    name: "zona-de-cliente-pedidos",
    path: "/zona-de-cliente/pedidos",
    meta: {"middleware":"only-authenticated"},
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/zona-de-cliente/pedidos/index.vue")
  },
  {
    name: "zona-de-cliente-cursos-courseId",
    path: "/zona-de-cliente/cursos/:courseId()",
    meta: {"middleware":"only-authenticated"},
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/zona-de-cliente/cursos/[courseId].vue")
  },
  {
    name: "tienda-categorySlug-productSlug",
    path: "/tienda/:categorySlug()/:productSlug()",
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/tienda/[categorySlug]/[productSlug].vue")
  },
  {
    name: "compra-pedido-realizado-orderNumber",
    path: "/compra/pedido-realizado/:orderNumber()",
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/compra/pedido-realizado/[orderNumber].vue")
  },
  {
    name: "cursos-online-para-profesionales-productSlug",
    path: "/cursos-online-para-profesionales/:productSlug()",
    component: () => import("/home/jmcastillo/projects/external/diprofem-frontend-v2/src/pages/cursos-online-para-profesionales/[productSlug].vue")
  }
]